/* Verified training-type facet uses native Shopify OR/AND filtering. Other vendors retain existing behavior. */
const spuIsInertVendor = () => location.pathname === '/collections/vendors' && new URLSearchParams(location.search).get('q') === 'Inert Products,LLC';
let spuInertFilterRequest = 0;
window.addEventListener('popstate', () => { if (spuIsInertVendor()) location.reload(); });
Woolman.Utils.prepareQueryParams();
Woolman.Collection = document.querySelector('[data-ajax-parent]');

/**
 * Generates search params from form data for filtering collection or search results.
 * @param {HTMLElement} formElement - Form element to turn into search params.
 * @returns
 */
const generateSearchParamsFromFormData = (formElement) => {
  const checkboxesToKeep = {};
  for (const element of formElement.elements) {
    const key = element.getAttribute('name');
    if (!key || !key.includes('filter')) continue;
    const value = element.value;
    const inputType = element.getAttribute('type');

    if (value === '') continue;

    if (inputType == 'number' && (element.hasAttribute('data-min') || element.hasAttribute('data-max'))) {
      if (!element.closest('price-range').hasAttribute('data-updated')) {
        continue;
      }
    }

    if (inputType == 'checkbox') {
      if (element.checked) {
        if (!checkboxesToKeep[key]) {
          checkboxesToKeep[key] = [value];
          continue;
        } else {
          checkboxesToKeep[key].push(value);
          continue;
        }
      }

      if (Shopify.queryParams[key] && !checkboxesToKeep[key]) {
        Shopify.queryParams[key] = undefined;
      }
      continue;
    } else {
      Shopify.queryParams[key] = value;
    }
  }

  if (Object.entries(checkboxesToKeep).length > 0) {
    for (const [key, value] of Object.entries(checkboxesToKeep)) {
      Shopify.queryParams[key] = value.join(',');
    }
  }

  return Shopify.queryParams;
};

/**
 * This function fetches fresh collection page via AJAX request to collection's url.
 * @param {Array} selectors - Array of HTML element selectors to update.
 */
const getCollectionAJAX = async (selectors) => {
  Shopify.queryParams.page = 1;
  const spuVendorRequest = spuIsInertVendor();
  const spuRequestNumber = spuVendorRequest ? ++spuInertFilterRequest : 0;
  if (spuVendorRequest && selectors && !selectors.includes('#facets')) selectors = [...selectors, '#facets'];
  if (selectors) {
    try {
      const url = location.pathname + '?' + getCollectionURL();
      const res = await fetch(url);
      const body = await res.text();
      if (spuVendorRequest && spuRequestNumber !== spuInertFilterRequest) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(body, 'text/html');

      for (const selector of selectors) {
        if (!document.querySelector(selector) || !doc.querySelector(selector)) continue;
        document.querySelector(selector).innerHTML = doc.querySelector(selector).innerHTML;
      }

      const historyStateUrl = location.pathname + '?' + getCollectionURL();
      if (spuVendorRequest) window.history.pushState('', '', historyStateUrl);
      else window.history.replaceState('', '', historyStateUrl);
      Woolman.Collection.classList.remove('processing');
      document.dispatchEvent(new CustomEvent('theme.filter.success'));
    } catch (err) {
      location.search = getCollectionURL();
    }
  } else {
    location.search = getCollectionURL();
  }
};

/**
 * Returns URL for current collection. Utilizes URL parameters to save user's filters, sorting and pagination.
 * @param {string} view - Template name to load with view attribute, e.g. 'ajax'
 * @returns
 */
const getCollectionURL = (view) => {
  Shopify.queryParams.view = view || undefined;
  const urlToReturn = new URLSearchParams(JSON.parse(JSON.stringify(Shopify.queryParams))).toString();
  return decodeURIComponent(urlToReturn);
};

class SortBySelect extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this.querySelector('select');
    this.selectors = {
      grid: '#product-grid-ajax',
      //facets: '#facets',
      //currentFacets: '#current-facets-ajax',
      pagination: '#pagination-ajax',
    };

    if (Shopify.queryParams['sort_by']) {
      this.el.value = Shopify.queryParams['sort_by'];
    }

    this.el.addEventListener('change', this.onSelectChange.bind(this));
  }

  async onSelectChange(event) {
    Woolman.Collection.classList.add('processing');
    Woolman.Utils.prepareQueryParams();
    const value = event.target.value;
    Shopify.queryParams.sort_by = value;
    getCollectionAJAX(Object.values(this.selectors));
  }
}

if (customElements.get('sort-by') === undefined) {
  customElements.define('sort-by', SortBySelect);
}

class FacetsForm extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this.querySelector('form');
    this.selectors = {
      grid: '#product-grid-ajax',
      //facets: '#facets',
      count: '#products-count-ajax',
      currentFacets: '#current-facets-ajax',
      pagination: '#pagination-ajax',
    };
    if (spuIsInertVendor()) {
      this.el.addEventListener('change', debounce(this.onCheckboxChanged.bind(this), 150));
    } else {
      const inputs = this.el.querySelectorAll('input');
      inputs.forEach((input) => {
        input.addEventListener('change', debounce(this.onCheckboxChanged.bind(this), 150));
      });
    }

    this.el.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  async onFormSubmit(event) {
    event.preventDefault();
    Woolman.Collection.classList.add('processing');
    Woolman.Utils.prepareQueryParams();
    generateSearchParamsFromFormData(this.el);

    Woolman.ModalsAndDrawers.closeModalOrDrawer(this.closest('[data-drawer]').getAttribute('id'));
    getCollectionAJAX(Object.values(this.selectors));
  }

  async onCheckboxChanged() {
    Woolman.Collection.classList.add('processing');
    generateSearchParamsFromFormData(this.el);
    getCollectionAJAX(Object.values(this.selectors));
  }
}

if (customElements.get('facets-form') === undefined) {
  customElements.define('facets-form', FacetsForm);
}

/* Controlled native facet counts. Read live public products, never prices from the manufacturer. */
(() => {
  if (!spuIsInertVendor()) return;
  const labels = {"f:training-type-rifles": "Replica rifles", "f:training-type-pistols": "Replica pistols", "f:training-type-launchers": "Replica launchers & kits", "f:training-type-blades": "Replica blades", "f:training-type-foam-weapons": "Foam training weapons", "f:training-type-recognition-kits": "Inert recognition kits", "f:training-type-ied-kits": "IED training kits"};
  let products = null;
  function values(params,key) { return params.getAll(key).flatMap(x => x.split(',')).filter(Boolean); }
  function matches(p,params,except) {
    const tags=except==='filter.p.tag'?[]:values(params,'filter.p.tag');
    if(tags.length && !tags.some(t => p.tags.includes(t))) return false;
    const types=except==='filter.p.product_type'?[]:values(params,'filter.p.product_type');
    if(types.length && !types.includes(p.type)) return false;
    const av=except==='filter.v.availability'?[]:values(params,'filter.v.availability');
    const min=params.get('filter.v.price.gte'),max=params.get('filter.v.price.lte');
    return p.variants.some(v=>(!av.length||av.includes(v.available?'1':'0'))&&(min===null||min===''||v.price>=Number(min)*100)&&(max===null||max===''||v.price<=Number(max)*100));
  }
  function refresh() {
    const params=new URLSearchParams(location.search),selected=values(params,'filter.p.tag');
    document.querySelectorAll('[data-spu-training-group] input').forEach(i=>{i.checked=selected.includes(i.value);});
    const chips=document.querySelector('[data-spu-training-chips]');
    if(chips) {
      chips.replaceChildren();
      selected.filter(t=>labels[t]).forEach(t=>{
        const u=new URL(location.href),rest=selected.filter(x=>x!==t);u.searchParams.delete('filter.p.tag');u.searchParams.delete('page');rest.forEach(x=>u.searchParams.append('filter.p.tag',x));
        const a=document.createElement('a');a.className='active-filters__remove-filter';a.href=u.pathname+u.search;a.textContent='Training type: '+labels[t]+' ×';chips.appendChild(a);
      });
    }
    if(!products) return;
    document.querySelectorAll('#facets input[type=checkbox]').forEach(i=>{
      const key=i.name;
      if(!['filter.p.tag','filter.p.product_type','filter.v.availability'].includes(key)) return;
      const subset=products.filter(p=>matches(p,params,key));
      const count=subset.filter(p=>key==='filter.p.tag'?p.tags.includes(i.value):key==='filter.p.product_type'?p.type===i.value:p.variants.some(v=>(v.available?'1':'0')===i.value)).length;
      const row=i.closest('li'),n=row&&row.querySelector('[data-spu-native-count]');
      if(n)n.textContent='('+count+')';
      if(row)row.hidden=count===0&&!i.checked;
    });
  }
  document.addEventListener('theme.filter.success',refresh);
  const load=async()=>{
    refresh();const rows=[];let total=null;
    for(let page=1;page<=30;page++){
      const u=new URL('/collections/vendors',location.origin);u.searchParams.set('q','Inert Products,LLC');u.searchParams.set('view','spu-training-facet-data');u.searchParams.set('page',String(page));
      const r=await fetch(u);if(!r.ok)throw Error('filter data unavailable');const d=await r.json();rows.push(...d.products);total=d.total;if(page>=d.pages)break;
    }
    if(rows.length!==total||new Set(rows.map(x=>x.id)).size!==total)throw Error('incomplete filter data');
    products=rows;refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>load().catch(()=>{}));else load().catch(()=>{});
})();
